<template>
	<div class="authority_error_code">
		<div style="width: 800px;">
			<template>
			    <el-table
				    :data="tableData"
				    :span-method="objectSpanMethod"
				    border
				    style="width: 100%">
				      	<el-table-column
					        prop="code"
					        label="Code"
					        width="120px">
				      	</el-table-column>
				      	<el-table-column
				        	prop="msg"
				        	label="Msg"
				        	width="240px">
				        	<template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.msg}}
					    		</div>
					    	</template>
				      	</el-table-column>
				      	<el-table-column
				        	prop="meaning"
				        	label="Meaning">
				        	<template scope="scope">
					    		<div class="table_msg">	
					    			{{scope.row.meaning}}
					    		</div>
					    	</template>
				      	</el-table-column>
			    </el-table>
			</template>
		</div>
	</div>
</template>
<script>
	export default{
		data(){
			return{
				tableData:[
					{
						"code":"0",
						"msg":"SUCCESS|20171231000000",
						"meaning":"授权成功",
					},
					{
						"code":"-1",
						"msg":"ERROR|20171231000000",
						"meaning":"授权已过期",
						
					},
					{
						"code":"-400",
						"msg":"ERROR400",
						"meaning":"无效的SDK授权[SDK没有被授权或者Key与Secret不正确]",
						
					},
					{
						"code":"-401",
						"msg":"ERROR401",
						"meaning":"无效的SDK授权[授权的终端ID不正确]",
					},
					{
						"code":"-402",
						"msg":"ERROR402",
						"meaning":"无法授权SDK的终端[无法获得终端ID/应用包名]",
						
					},
					{
						"code":"-403",
						"msg":"ERROR403",
						"meaning":"无效的SDK授权[授权文件损坏]",
						
					},
					{
						"code":"-404",
						"msg":"ERROR404",
						"meaning":"无法找到授权文件",
						
					},
					{
						"code":"-500",
						"msg":"ERROR500",
						"meaning":"授权失败（无法访问网络）",
						
					},
					{
						"code":"-501",
						"msg":"ERROR501",
						"meaning":"该SDK 的有效激活次数已用完",
						
					},
					{
						"code":"-502",
						"msg":"ERROR502",
						"meaning":"该SDK的使用权限已到期",
						
					},
					{
						"code":"-503",
						"msg":"ERROR503",
						"meaning":"API Key 或API Secret无效",
						
					},
					{
						"code":"-504",
						"msg":"ERROR504",
						"meaning":"当前应用配置未配置该SDK的使用权限",
						
					},
					{
						"code":"-505",
						"msg":"ERROR505",
						"meaning":"应用信息有误（建议检查应用包名/应用Bundle ID/应用程序名是否与创建信息一致）",
						
					},
					{
						"code":"-506",
						"msg":"ERROR506",
						"meaning":"应用信息有误（建议检查应用平台信息是否有误）",
						
					},
					{
						"code":"-507",
						"msg":"ERROR507",
						"meaning":"唯一终端号为空",
						
					},
					{
						"code":"-601",
						"msg":"ERROR601",
						"meaning":"本地路径创建失败（请检查应用读写权限是否打开）",
						
					},
					{
						"code":"1001",
						"msg":"该SDK的有效激活次数已用完",
						"meaning":"该SDK的有效激活次数已用完",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1002",
						"msg":"该SDK的使用权限已到期",
						"meaning":"该SDK的使用权限已到期",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1003",
						"msg":"API Key或API Secret无效",
						"meaning":"API Key或API Secret无效",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1004",
						"msg":"当前应用配置未配置该SDK的使用权限",
						"meaning":"当前应用配置未配置该SDK的使用权限",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1005",
						"msg":"应用信息有误（建议检查应用包名/应用Bundle ID/应用程序名是否与创建信息一致）",
						"meaning":"应用信息有误（建议检查应用包名/应用Bundle ID/应用程序名是否与创建信息一致）",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1006",
						"msg":"应用信息有误（建议检查应用平台信息是否有误）",
						"meaning":"应用信息有误（建议检查应用平台信息是否有误）",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1007",
						"msg":"唯一终端号为空",
						"meaning":"唯一终端号为空",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1008",
						"msg":"API Secret无效",
						"meaning":"API Secret无效",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1009",
						"msg":"您的终端已被列如黑名单，请联系盛开技术支持",
						"meaning":"您的终端已被列如黑名单，请联系盛开技术支持",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1010",
						"msg":"您的应用已被锁定，请联系盛开技术支持",
						"meaning":"您的应用已被锁定，请联系盛开技术支持",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1011",
						"msg":"您的SDK使用权限已被禁用，请联系盛开技术支持",
						"meaning":"您的SDK使用权限已被禁用，请联系盛开技术支持",
						"colspan":2,
						"rowspan":1,
					},
					{
						"code":"1012",
						"msg":"该SDK已被禁用，请联系盛开技术支持",
						"meaning":"该SDK已被禁用，请联系盛开技术支持",
						"colspan":2,
						"rowspan":1,
					},
				],
			}
		},
		methods:{
			objectSpanMethod({ row, column, rowIndex, columnIndex }){
				console.log(row, column, rowIndex, columnIndex)
		  		if (row.colspan) {
			        if (columnIndex === 1) {
			            return [1, 2];
			        } else if (columnIndex === 2) {
			            return [0, 0];
			        }
		        }	
			}
		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../less/index.less';
	.authority_error_code{
		//margin:5px 0 30px 30px;
		margin:5px 0 30px 0;
		thead{
			tr{
				th{
					padding:15px 0;
					background: #F5F7FA;
					color:#333;
				}
			}
			
		}
		.cell{
			text-align: center;
			color:#2c3e50;;
			.table_msg{
				text-align: left;
				.table_msg_list{
					padding: 2px 0;
				}
			}
		}
		tbody{
			td{
				padding:8px 0;
			}
		}	
		
	}
</style>	


// WEBPACK FOOTER //
// src/components/authorityErrorCode.vue